let countries = [
  {
    country: "Vietnam",
    value: "+84",
    code: "VN",
    emoji: "🇻🇳",
  },
  {
    country: "South Korea",
    value: "+82",
    code: "KR",
    emoji: "🇰🇷",
  },
  {
    country: "Japan",
    value: "+81",
    code: "JP",
    emoji: "🇯🇵",
  },
  {
    country: "China",
    value: "+86",
    code: "CN",
    emoji: "🇨🇳",
  },
  {
    country: "Hong Kong",
    value: "+852",
    code: "HK",
    emoji: "🇭🇰",
  },
  {
    country: "Thailand",
    value: "+66",
    code: "TH",
    emoji: "🇹🇭",
  },
  {
    country: "Singapore",
    value: "+65",
    code: "SG",
    emoji: "🇸🇬",
  },
  {
    country: "Malaysia",
    value: "+60",
    code: "MY",
    emoji: "🇲🇾",
  },
  {
    country: "United States",
    value: "+1",
    code: "US",
    emoji: "🇺🇸",
  },

  {
    country: "Afghanistan",
    value: "+93",
    code: "AF",
    emoji: "🇦🇫",
  },
  {
    country: "Albania",
    value: "+355",
    code: "AL",
    emoji: "🇦🇱",
  },
  {
    country: "Algeria",
    value: "+213",
    code: "DZ",
    emoji: "🇩🇿",
  },
  {
    country: "American Samoa",
    value: "+1-684",
    code: "AS",
    emoji: "🇦🇸",
  },
  {
    country: "Andorra",
    value: "+376",
    code: "AD",
    emoji: "🇦🇩",
  },
  {
    country: "Angola",
    value: "+244",
    code: "AO",
    emoji: "🇦🇴",
  },
  {
    country: "Anguilla",
    value: "+1-264",
    code: "AI",
    emoji: "🇦🇮",
  },
  {
    country: "Antarctica",
    value: "+672",
    code: "AQ",
    emoji: "🇦🇶",
  },
  {
    country: "Antigua and Barbuda",
    value: "+1-268",
    code: "AG",
    emoji: "🇦🇬",
  },
  {
    country: "Argentina",
    value: "+54",
    code: "AR",
    emoji: "🇦🇷",
  },
  {
    country: "Armenia",
    value: "+374",
    code: "AM",
    emoji: "🇦🇲",
  },
  {
    country: "Aruba",
    value: "+297",
    code: "AW",
    emoji: "🇦🇼",
  },
  {
    country: "Australia",
    value: "+61",
    code: "AU",
    emoji: "🇦🇺",
  },
  {
    country: "Austria",
    value: "+43",
    code: "AT",
    emoji: "🇦🇹",
  },
  {
    country: "Azerbaijan",
    value: "+994",
    code: "AZ",
    emoji: "🇦🇿",
  },
  {
    country: "Bahamas",
    value: "+1-242",
    code: "BS",
    emoji: "🇧🇸",
  },
  {
    country: "Bahrain",
    value: "+973",
    code: "BH",
    emoji: "🇧🇭",
  },
  {
    country: "Bangladesh",
    value: "+880",
    code: "BD",
    emoji: "🇧🇩",
  },
  {
    country: "Barbados",
    value: "+1-246",
    code: "BB",
    emoji: "🇧🇧",
  },
  {
    country: "Belarus",
    value: "+375",
    code: "BY",
    emoji: "🇧🇾",
  },
  {
    country: "Belgium",
    value: "+32",
    code: "BE",
    emoji: "🇧🇪",
  },
  {
    country: "Belize",
    value: "+501",
    code: "BZ",
    emoji: "🇧🇿",
  },
  {
    country: "Benin",
    value: "+229",
    code: "BJ",
    emoji: "🇧🇯",
  },
  {
    country: "Bermuda",
    value: "+1-441",
    code: "BM",
    emoji: "🇧🇲",
  },
  {
    country: "Bhutan",
    value: "+975",
    code: "BT",
    emoji: "🇧🇹",
  },
  {
    country: "Bolivia",
    value: "+591",
    code: "BO",
    emoji: "🇧🇴",
  },
  {
    country: "Bosnia and Herzegovina",
    value: "+387",
    code: "BA",
    emoji: "🇧🇦",
  },
  {
    country: "Botswana",
    value: "+267",
    code: "BW",
    emoji: "🇧🇼",
  },
  {
    country: "Brazil",
    value: "+55",
    code: "BR",
    emoji: "🇧🇷",
  },
  {
    country: "British Indian Ocean Territory",
    value: "+246",
    code: "IO",
    emoji: "🇮🇴",
  },
  {
    country: "British Virgin Islands",
    value: "+1-284",
    code: "VG",
    emoji: "🇻🇬",
  },
  {
    country: "Brunei",
    value: "+673",
    code: "BN",
    emoji: "🇧🇳",
  },
  {
    country: "Bulgaria",
    value: "+359",
    code: "BG",
    emoji: "🇧🇬",
  },
  {
    country: "Burkina Faso",
    value: "+226",
    code: "BF",
    emoji: "🇧🇫",
  },
  {
    country: "Burundi",
    value: "+257",
    code: "BI",
    emoji: "🇧🇮",
  },
  {
    country: "Cambodia",
    value: "+855",
    code: "KH",
    emoji: "🇰🇭",
  },
  {
    country: "Cameroon",
    value: "+237",
    code: "CM",
    emoji: "🇨🇲",
  },
  {
    country: "Canada",
    value: "+1",
    code: "CA",
    emoji: "🇨🇦",
  },
  {
    country: "Cape Verde",
    value: "+238",
    code: "CV",
    emoji: "🇨🇻",
  },
  {
    country: "Cayman Islands",
    value: "+1-345",
    code: "KY",
    emoji: "🇰🇾",
  },
  {
    country: "Central African Republic",
    value: "+236",
    code: "CF",
    emoji: "🇨🇫",
  },
  {
    country: "Chad",
    value: "+235",
    code: "TD",
    emoji: "🇹🇩",
  },
  {
    country: "Chile",
    value: "+56",
    code: "CL",
    emoji: "🇨🇱",
  },

  {
    country: "Christmas Island",
    value: "+61",
    code: "CX",
    emoji: "🇨🇽",
  },
  {
    country: "Cocos Islands",
    value: "+61",
    code: "CC",
    emoji: "🇨🇨",
  },
  {
    country: "Colombia",
    value: "+57",
    code: "CO",
    emoji: "🇨🇴",
  },
  {
    country: "Comoros",
    value: "+269",
    code: "KM",
    emoji: "🇰🇲",
  },
  {
    country: "Cook Islands",
    value: "+682",
    code: "CK",
    emoji: "🇨🇰",
  },
  {
    country: "Costa Rica",
    value: "+506",
    code: "CR",
    emoji: "🇨🇷",
  },
  {
    country: "Croatia",
    value: "+385",
    code: "HR",
    emoji: "🇭🇷",
  },
  {
    country: "Cuba",
    value: "+53",
    code: "CU",
    emoji: "🇨🇺",
  },
  {
    country: "Curacao",
    value: "+599",
    code: "CW",
    emoji: "🇨🇼",
  },
  {
    country: "Cyprus",
    value: "+357",
    code: "CY",
    emoji: "🇨🇾",
  },
  {
    country: "Czech Republic",
    value: "+420",
    code: "CZ",
    emoji: "🇨🇿",
  },
  {
    country: "Democratic Republic of the Congo",
    value: "+243",
    code: "CD",
    emoji: "🇨🇩",
  },
  {
    country: "Denmark",
    value: "+45",
    code: "DK",
    emoji: "🇩🇰",
  },
  {
    country: "Djibouti",
    value: "+253",
    code: "DJ",
    emoji: "🇩🇯",
  },
  {
    country: "Dominica",
    value: "+1-767",
    code: "DM",
    emoji: "🇩🇲",
  },
  {
    country: "Dominican Republic (1-809)",
    value: "+1-809",
    code: "DO",
    emoji: "🇩🇴",
  },
  {
    country: "Dominican Republic (1-829)",
    value: "+1-829",
    code: "DO",
    emoji: "🇩🇴",
  },
  {
    country: "Dominican Republic (1-849)",
    value: "+1-849",
    code: "DO",
    emoji: "🇩🇴",
  },
  {
    country: "East Timor",
    value: "+670",
    code: "TL",
    emoji: "🇹🇱",
  },
  {
    country: "Ecuador",
    value: "+593",
    code: "EC",
    emoji: "🇪🇨",
  },
  {
    country: "Egypt",
    value: "+20",
    code: "EG",
    emoji: "🇪🇬",
  },
  {
    country: "El Salvador",
    value: "+503",
    code: "SV",
    emoji: "🇸🇻",
  },
  {
    country: "Equatorial Guinea",
    value: "+240",
    code: "GQ",
    emoji: "🇬🇶",
  },
  {
    country: "Eritrea",
    value: "+291",
    code: "ER",
    emoji: "🇪🇷",
  },
  {
    country: "Estonia",
    value: "+372",
    code: "EE",
    emoji: "🇪🇪",
  },
  {
    country: "Ethiopia",
    value: "+251",
    code: "ET",
    emoji: "🇪🇹",
  },
  {
    country: "Falkland Islands",
    value: "+500",
    code: "FK",
    emoji: "🇫🇰",
  },
  {
    country: "Faroe Islands",
    value: "+298",
    code: "FO",
    emoji: "🇫🇴",
  },
  {
    country: "Fiji",
    value: "+679",
    code: "FJ",
    emoji: "🇫🇯",
  },
  {
    country: "Finland",
    value: "+358",
    code: "FI",
    emoji: "🇫🇮",
  },
  {
    country: "France",
    value: "+33",
    code: "FR",
    emoji: "🇫🇷",
  },
  {
    country: "French Polynesia",
    value: "+689",
    code: "PF",
    emoji: "🇵🇫",
  },
  {
    country: "Gabon",
    value: "+241",
    code: "GA",
    emoji: "🇬🇦",
  },
  {
    country: "Gambia",
    value: "+220",
    code: "GM",
    emoji: "🇬🇲",
  },
  {
    country: "Georgia",
    value: "+995",
    code: "GE",
    emoji: "🇬🇪",
  },
  {
    country: "Germany",
    value: "+49",
    code: "DE",
    emoji: "🇩🇪",
  },
  {
    country: "Ghana",
    value: "+233",
    code: "GH",
    emoji: "🇬🇭",
  },
  {
    country: "Gibraltar",
    value: "+350",
    code: "GI",
    emoji: "🇬🇮",
  },
  {
    country: "Greece",
    value: "+30",
    code: "GR",
    emoji: "🇬🇷",
  },
  {
    country: "Greenland",
    value: "+299",
    code: "GL",
    emoji: "🇬🇱",
  },
  {
    country: "Grenada",
    value: "+1-473",
    code: "GD",
    emoji: "🇬🇩",
  },
  {
    country: "Guam",
    value: "+1-671",
    code: "GU",
    emoji: "🇬🇺",
  },
  {
    country: "Guatemala",
    value: "+502",
    code: "GT",
    emoji: "🇬🇹",
  },
  {
    country: "Guernsey",
    value: "+44-1481",
    code: "GG",
    emoji: "🇬🇬",
  },
  {
    country: "Guinea",
    value: "+224",
    code: "GN",
    emoji: "🇬🇳",
  },
  {
    country: "Guinea-Bissau",
    value: "+245",
    code: "GW",
    emoji: "🇬🇼",
  },
  {
    country: "Guyana",
    value: "+592",
    code: "GY",
    emoji: "🇬🇾",
  },
  {
    country: "Haiti",
    value: "+509",
    code: "HT",
    emoji: "🇭🇹",
  },
  {
    country: "Honduras",
    value: "+504",
    code: "HN",
    emoji: "🇭🇳",
  },

  {
    country: "Hungary",
    value: "+36",
    code: "HU",
    emoji: "🇭🇺",
  },
  {
    country: "Iceland",
    value: "+354",
    code: "IS",
    emoji: "🇮🇸",
  },
  {
    country: "India",
    value: "+91",
    code: "IN",
    emoji: "🇮🇳",
  },
  {
    country: "Indonesia",
    value: "+62",
    code: "ID",
    emoji: "🇮🇩",
  },
  {
    country: "Iran",
    value: "+98",
    code: "IR",
    emoji: "🇮🇷",
  },
  {
    country: "Iraq",
    value: "+964",
    code: "IQ",
    emoji: "🇮🇶",
  },
  {
    country: "Ireland",
    value: "+353",
    code: "IE",
    emoji: "🇮🇪",
  },
  {
    country: "Isle of Man",
    value: "+44-1624",
    code: "IM",
    emoji: "🇮🇲",
  },
  {
    country: "Israel",
    value: "+972",
    code: "IL",
    emoji: "🇮🇱",
  },
  {
    country: "Italy",
    value: "+39",
    code: "IT",
    emoji: "🇮🇹",
  },
  {
    country: "Ivory Coast",
    value: "+225",
    code: "CI",
    emoji: "🇨🇮",
  },
  {
    country: "Jamaica",
    value: "+1-876",
    code: "JM",
    emoji: "🇯🇲",
  },

  {
    country: "Jersey",
    value: "+44-1534",
    code: "JE",
    emoji: "🇯🇪",
  },
  {
    country: "Jordan",
    value: "+962",
    code: "JO",
    emoji: "🇯🇴",
  },
  {
    country: "Kazakhstan",
    value: "+7",
    code: "KZ",
    emoji: "🇰🇿",
  },
  {
    country: "Kenya",
    value: "+254",
    code: "KE",
    emoji: "🇰🇪",
  },
  {
    country: "Kiribati",
    value: "+686",
    code: "KI",
    emoji: "🇰🇮",
  },
  {
    country: "Kosovo",
    value: "+383",
    code: "XK",
    emoji: "🇽🇰",
  },
  {
    country: "Kuwait",
    value: "+965",
    code: "KW",
    emoji: "🇰🇼",
  },
  {
    country: "Kyrgyzstan",
    value: "+996",
    code: "KG",
    emoji: "🇰🇬",
  },
  {
    country: "Laos",
    value: "+856",
    code: "LA",
    emoji: "🇱🇦",
  },
  {
    country: "Latvia",
    value: "+371",
    code: "LV",
    emoji: "🇱🇻",
  },
  {
    country: "Lebanon",
    value: "+961",
    code: "LB",
    emoji: "🇱🇧",
  },
  {
    country: "Lesotho",
    value: "+266",
    code: "LS",
    emoji: "🇱🇸",
  },
  {
    country: "Liberia",
    value: "+231",
    code: "LR",
    emoji: "🇱🇷",
  },
  {
    country: "Libya",
    value: "+218",
    code: "LY",
    emoji: "🇱🇾",
  },
  {
    country: "Liechtenstein",
    value: "+423",
    code: "LI",
    emoji: "🇱🇮",
  },
  {
    country: "Lithuania",
    value: "+370",
    code: "LT",
    emoji: "🇱🇹",
  },
  {
    country: "Luxembourg",
    value: "+352",
    code: "LU",
    emoji: "🇱🇺",
  },
  {
    country: "Macau",
    value: "+853",
    code: "MO",
    emoji: "🇲🇴",
  },
  {
    country: "Macedonia",
    value: "+389",
    code: "MK",
    emoji: "🇲🇰",
  },
  {
    country: "Madagascar",
    value: "+261",
    code: "MG",
    emoji: "🇲🇬",
  },
  {
    country: "Malawi",
    value: "+265",
    code: "MW",
    emoji: "🇲🇼",
  },

  {
    country: "Maldives",
    value: "+960",
    code: "MV",
    emoji: "🇲🇻",
  },
  {
    country: "Mali",
    value: "+223",
    code: "ML",
    emoji: "🇲🇱",
  },
  {
    country: "Malta",
    value: "+356",
    code: "MT",
    emoji: "🇲🇹",
  },
  {
    country: "Marshall Islands",
    value: "+692",
    code: "MH",
    emoji: "🇲🇭",
  },
  {
    country: "Mauritania",
    value: "+222",
    code: "MR",
    emoji: "🇲🇷",
  },
  {
    country: "Mauritius",
    value: "+230",
    code: "MU",
    emoji: "🇲🇺",
  },
  {
    country: "Mayotte",
    value: "+262",
    code: "YT",
    emoji: "🇾🇹",
  },
  {
    country: "Mexico",
    value: "+52",
    code: "MX",
    emoji: "🇲🇽",
  },
  {
    country: "Micronesia",
    value: "+691",
    code: "FM",
    emoji: "🇫🇲",
  },
  {
    country: "Moldova",
    value: "+373",
    code: "MD",
    emoji: "🇲🇩",
  },
  {
    country: "Monaco",
    value: "+377",
    code: "MC",
    emoji: "🇲🇨",
  },
  {
    country: "Mongolia",
    value: "+976",
    code: "MN",
    emoji: "🇲🇳",
  },
  {
    country: "Montenegro",
    value: "+382",
    code: "ME",
    emoji: "🇲🇪",
  },
  {
    country: "Montserrat",
    value: "+1-664",
    code: "MS",
    emoji: "🇲🇸",
  },
  {
    country: "Morocco",
    value: "+212",
    code: "MA",
    emoji: "🇲🇦",
  },
  {
    country: "Mozambique",
    value: "+258",
    code: "MZ",
    emoji: "🇲🇿",
  },
  {
    country: "Myanmar",
    value: "+95",
    code: "MM",
    emoji: "🇲🇲",
  },
  {
    country: "Namibia",
    value: "+264",
    code: "NA",
    emoji: "🇳🇦",
  },
  {
    country: "Nauru",
    value: "+674",
    code: "NR",
    emoji: "🇳🇷",
  },
  {
    country: "Nepal",
    value: "+977",
    code: "NP",
    emoji: "🇳🇵",
  },
  {
    country: "Netherlands",
    value: "+31",
    code: "NL",
    emoji: "🇳🇱",
  },
  {
    country: "Netherlands Antilles",
    value: "+599",
    code: "AN",
  },
  {
    country: "New Caledonia",
    value: "+687",
    code: "NC",
    emoji: "🇳🇨",
  },
  {
    country: "New Zealand",
    value: "+64",
    code: "NZ",
    emoji: "🇳🇿",
  },
  {
    country: "Nicaragua",
    value: "+505",
    code: "NI",
    emoji: "🇳🇮",
  },
  {
    country: "Niger",
    value: "+227",
    code: "NE",
    emoji: "🇳🇪",
  },
  {
    country: "Nigeria",
    value: "+234",
    code: "NG",
    emoji: "🇳🇬",
  },
  {
    country: "Niue",
    value: "+683",
    code: "NU",
    emoji: "🇳🇺",
  },
  {
    country: "North Korea",
    value: "+850",
    code: "KP",
    emoji: "🇰🇵",
  },
  {
    country: "Northern Mariana Islands",
    value: "+1-670",
    code: "MP",
    emoji: "🇲🇵",
  },
  {
    country: "Norway",
    value: "+47",
    code: "NO",
    emoji: "🇳🇴",
  },
  {
    country: "Oman",
    value: "+968",
    code: "OM",
    emoji: "🇴🇲",
  },
  {
    country: "Pakistan",
    value: "+92",
    code: "PK",
    emoji: "🇵🇰",
  },
  {
    country: "Palau",
    value: "+680",
    code: "PW",
    emoji: "🇵🇼",
  },
  {
    country: "Palestine",
    value: "+970",
    code: "PS",
    emoji: "🇵🇸",
  },
  {
    country: "Panama",
    value: "+507",
    code: "PA",
    emoji: "🇵🇦",
  },
  {
    country: "Papua New Guinea",
    value: "+675",
    code: "PG",
    emoji: "🇵🇬",
  },
  {
    country: "Paraguay",
    value: "+595",
    code: "PY",
    emoji: "🇵🇾",
  },
  {
    country: "Peru",
    value: "+51",
    code: "PE",
    emoji: "🇵🇪",
  },
  {
    country: "Philippines",
    value: "+63",
    code: "PH",
    emoji: "🇵🇭",
  },
  {
    country: "Pitcairn",
    value: "+64",
    code: "PN",
    emoji: "🇵🇳",
  },
  {
    country: "Poland",
    value: "+48",
    code: "PL",
    emoji: "🇵🇱",
  },
  {
    country: "Portugal",
    value: "+351",
    code: "PT",
    emoji: "🇵🇹",
  },
  {
    country: "Puerto Rico (1-787)",
    value: "+1-787",
    code: "PR",
    emoji: "🇵🇷",
  },
  {
    country: "Puerto Rico (1-939)",
    value: "+1-939",
    code: "PR",
    emoji: "🇵🇷",
  },
  {
    country: "Qatar",
    value: "+974",
    code: "QA",
    emoji: "🇶🇦",
  },
  {
    country: "Republic of the Congo",
    value: "+242",
    code: "CG",
    emoji: "🇨🇬",
  },
  {
    country: "Reunion",
    value: "+262",
    code: "RE",
    emoji: "🇷🇪",
  },
  {
    country: "Romania",
    value: "+40",
    code: "RO",
    emoji: "🇷🇴",
  },
  {
    country: "Russia",
    value: "+7",
    code: "RU",
    emoji: "🇷🇺",
  },
  {
    country: "Rwanda",
    value: "+250",
    code: "RW",
    emoji: "🇷🇼",
  },
  {
    country: "Saint Barthelemy",
    value: "+590",
    code: "BL",
    emoji: "🇧🇱",
  },
  {
    country: "Saint Helena",
    value: "+290",
    code: "SH",
    emoji: "🇸🇭",
  },
  {
    country: "Saint Kitts and Nevis",
    value: "+1-869",
    code: "KN",
    emoji: "🇰🇳",
  },
  {
    country: "Saint Lucia",
    value: "+1-758",
    code: "LC",
    emoji: "🇱🇨",
  },
  {
    country: "Saint Martin",
    value: "+590",
    code: "MF",
    emoji: "🇲🇫",
  },
  {
    country: "Saint Pierre and Miquelon",
    value: "+508",
    code: "PM",
    emoji: "🇵🇲",
  },
  {
    country: "Saint Vincent and the Grenadines",
    value: "+1-784",
    code: "VC",
    emoji: "🇻🇨",
  },
  {
    country: "Samoa",
    value: "+685",
    code: "WS",
    emoji: "🇼🇸",
  },
  {
    country: "San Marino",
    value: "+378",
    code: "SM",
    emoji: "🇸🇲",
  },
  {
    country: "Sao Tome and Principe",
    value: "+239",
    code: "ST",
    emoji: "🇸🇹",
  },
  {
    country: "Saudi Arabia",
    value: "+966",
    code: "SA",
    emoji: "🇸🇦",
  },
  {
    country: "Senegal",
    value: "+221",
    code: "SN",
    emoji: "🇸🇳",
  },
  {
    country: "Serbia",
    value: "+381",
    code: "RS",
    emoji: "🇷🇸",
  },
  {
    country: "Seychelles",
    value: "+248",
    code: "SC",
    emoji: "🇸🇨",
  },
  {
    country: "Sierra Leone",
    value: "+232",
    code: "SL",
    emoji: "🇸🇱",
  },

  {
    country: "Sint Maarten",
    value: "+1-721",
    code: "SX",
    emoji: "🇸🇽",
  },
  {
    country: "Slovakia",
    value: "+421",
    code: "SK",
    emoji: "🇸🇰",
  },
  {
    country: "Slovenia",
    value: "+386",
    code: "SI",
    emoji: "🇸🇮",
  },
  {
    country: "Solomon Islands",
    value: "+677",
    code: "SB",
    emoji: "🇸🇧",
  },
  {
    country: "Somalia",
    value: "+252",
    code: "SO",
    emoji: "🇸🇴",
  },
  {
    country: "South Africa",
    value: "+27",
    code: "ZA",
    emoji: "🇿🇦",
  },

  {
    country: "South Sudan",
    value: "+211",
    code: "SS",
    emoji: "🇸🇸",
  },
  {
    country: "Spain",
    value: "+34",
    code: "ES",
    emoji: "🇪🇸",
  },
  {
    country: "Sri Lanka",
    value: "+94",
    code: "LK",
    emoji: "🇱🇰",
  },
  {
    country: "Sudan",
    value: "+249",
    code: "SD",
    emoji: "🇸🇩",
  },
  {
    country: "Suriname",
    value: "+597",
    code: "SR",
    emoji: "🇸🇷",
  },
  {
    country: "Svalbard and Jan Mayen",
    value: "+47",
    code: "SJ",
    emoji: "🇸🇯",
  },
  {
    country: "Swaziland",
    value: "+268",
    code: "SZ",
    emoji: "🇸🇿",
  },
  {
    country: "Sweden",
    value: "+46",
    code: "SE",
    emoji: "🇸🇪",
  },
  {
    country: "Switzerland",
    value: "+41",
    code: "CH",
    emoji: "🇨🇭",
  },
  {
    country: "Syria",
    value: "+963",
    code: "SY",
    emoji: "🇸🇾",
  },
  {
    country: "Taiwan",
    value: "+886",
    code: "TW",
    emoji: "🇹🇼",
  },
  {
    country: "Tajikistan",
    value: "+992",
    code: "TJ",
    emoji: "🇹🇯",
  },
  {
    country: "Tanzania",
    value: "+255",
    code: "TZ",
    emoji: "🇹🇿",
  },

  {
    country: "Togo",
    value: "+228",
    code: "TG",
    emoji: "🇹🇬",
  },
  {
    country: "Tokelau",
    value: "+690",
    code: "TK",
    emoji: "🇹🇰",
  },
  {
    country: "Tonga",
    value: "+676",
    code: "TO",
    emoji: "🇹🇴",
  },
  {
    country: "Trinidad and Tobago",
    value: "+1-868",
    code: "TT",
    emoji: "🇹🇹",
  },
  {
    country: "Tunisia",
    value: "+216",
    code: "TN",
    emoji: "🇹🇳",
  },
  {
    country: "Turkey",
    value: "+90",
    code: "TR",
    emoji: "🇹🇷",
  },
  {
    country: "Turkmenistan",
    value: "+993",
    code: "TM",
    emoji: "🇹🇲",
  },
  {
    country: "Turks and Caicos Islands",
    value: "+1-649",
    code: "TC",
    emoji: "🇹🇨",
  },
  {
    country: "Tuvalu",
    value: "+688",
    code: "TV",
    emoji: "🇹🇻",
  },
  {
    country: "U.S. Virgin Islands",
    value: "+1-340",
    code: "VI",
    emoji: "🇻🇮",
  },
  {
    country: "Uganda",
    value: "+256",
    code: "UG",
    emoji: "🇺🇬",
  },
  {
    country: "Ukraine",
    value: "+380",
    code: "UA",
    emoji: "🇺🇦",
  },
  {
    country: "United Arab Emirates",
    value: "+971",
    code: "AE",
    emoji: "🇦🇪",
  },
  {
    country: "United Kingdom",
    value: "+44",
    code: "GB",
    emoji: "🇬🇧",
  },

  {
    country: "Uruguay",
    value: "+598",
    code: "UY",
    emoji: "🇺🇾",
  },
  {
    country: "Uzbekistan",
    value: "+998",
    code: "UZ",
    emoji: "🇺🇿",
  },
  {
    country: "Vanuatu",
    value: "+678",
    code: "VU",
    emoji: "🇻🇺",
  },
  {
    country: "Vatican",
    value: "+379",
    code: "VA",
    emoji: "🇻🇦",
  },
  {
    country: "Venezuela",
    value: "+58",
    code: "VE",
    emoji: "🇻🇪",
  },

  {
    country: "Wallis and Futuna",
    value: "+681",
    code: "WF",
    emoji: "🇼🇫",
  },
  {
    country: "Western Sahara",
    value: "+212",
    code: "EH",
    emoji: "🇪🇭",
  },
  {
    country: "Yemen",
    value: "+967",
    code: "YE",
    emoji: "🇾🇪",
  },
  {
    country: "Zambia",
    value: "+260",
    code: "ZM",
    emoji: "🇿🇲",
  },
  {
    country: "Zimbabwe",
    value: "+263",
    code: "ZW",
    emoji: "🇿🇼",
  },
];
function getFlags($code) {
  $code = strtoupper($code);
  if ($code == 'AD') return '🇦🇩';
  if ($code == 'AE') return '🇦🇪';
  if ($code == 'AF') return '🇦🇫';
  if ($code == 'AG') return '🇦🇬';
  if ($code == 'AI') return '🇦🇮';
  if ($code == 'AL') return '🇦🇱';
  if ($code == 'AM') return '🇦🇲';
  if ($code == 'AO') return '🇦🇴';
  if ($code == 'AQ') return '🇦🇶';
  if ($code == 'AR') return '🇦🇷';
  if ($code == 'AS') return '🇦🇸';
  if ($code == 'AT') return '🇦🇹';
  if ($code == 'AU') return '🇦🇺';
  if ($code == 'AW') return '🇦🇼';
  if ($code == 'AX') return '🇦🇽';
  if ($code == 'AZ') return '🇦🇿';
  if ($code == 'BA') return '🇧🇦';
  if ($code == 'BB') return '🇧🇧';
  if ($code == 'BD') return '🇧🇩';
  if ($code == 'BE') return '🇧🇪';
  if ($code == 'BF') return '🇧🇫';
  if ($code == 'BG') return '🇧🇬';
  if ($code == 'BH') return '🇧🇭';
  if ($code == 'BI') return '🇧🇮';
  if ($code == 'BJ') return '🇧🇯';
  if ($code == 'BL') return '🇧🇱';
  if ($code == 'BM') return '🇧🇲';
  if ($code == 'BN') return '🇧🇳';
  if ($code == 'BO') return '🇧🇴';
  if ($code == 'BQ') return '🇧🇶';
  if ($code == 'BR') return '🇧🇷';
  if ($code == 'BS') return '🇧🇸';
  if ($code == 'BT') return '🇧🇹';
  if ($code == 'BV') return '🇧🇻';
  if ($code == 'BW') return '🇧🇼';
  if ($code == 'BY') return '🇧🇾';
  if ($code == 'BZ') return '🇧🇿';
  if ($code == 'CA') return '🇨🇦';
  if ($code == 'CC') return '🇨🇨';
  if ($code == 'CD') return '🇨🇩';
  if ($code == 'CF') return '🇨🇫';
  if ($code == 'CG') return '🇨🇬';
  if ($code == 'CH') return '🇨🇭';
  if ($code == 'CI') return '🇨🇮';
  if ($code == 'CK') return '🇨🇰';
  if ($code == 'CL') return '🇨🇱';
  if ($code == 'CM') return '🇨🇲';
  if ($code == 'CN') return '🇨🇳';
  if ($code == 'CO') return '🇨🇴';
  if ($code == 'CR') return '🇨🇷';
  if ($code == 'CU') return '🇨🇺';
  if ($code == 'CV') return '🇨🇻';
  if ($code == 'CW') return '🇨🇼';
  if ($code == 'CX') return '🇨🇽';
  if ($code == 'CY') return '🇨🇾';
  if ($code == 'CZ') return '🇨🇿';
  if ($code == 'DE') return '🇩🇪';
  if ($code == 'DJ') return '🇩🇯';
  if ($code == 'DK') return '🇩🇰';
  if ($code == 'DM') return '🇩🇲';
  if ($code == 'DO') return '🇩🇴';
  if ($code == 'DZ') return '🇩🇿';
  if ($code == 'EC') return '🇪🇨';
  if ($code == 'EE') return '🇪🇪';
  if ($code == 'EG') return '🇪🇬';
  if ($code == 'EH') return '🇪🇭';
  if ($code == 'ER') return '🇪🇷';
  if ($code == 'ES') return '🇪🇸';
  if ($code == 'ET') return '🇪🇹';
  if ($code == 'FI') return '🇫🇮';
  if ($code == 'FJ') return '🇫🇯';
  if ($code == 'FK') return '🇫🇰';
  if ($code == 'FM') return '🇫🇲';
  if ($code == 'FO') return '🇫🇴';
  if ($code == 'FR') return '🇫🇷';
  if ($code == 'GA') return '🇬🇦';
  if ($code == 'GB') return '🇬🇧';
  if ($code == 'GD') return '🇬🇩';
  if ($code == 'GE') return '🇬🇪';
  if ($code == 'GF') return '🇬🇫';
  if ($code == 'GG') return '🇬🇬';
  if ($code == 'GH') return '🇬🇭';
  if ($code == 'GI') return '🇬🇮';
  if ($code == 'GL') return '🇬🇱';
  if ($code == 'GM') return '🇬🇲';
  if ($code == 'GN') return '🇬🇳';
  if ($code == 'GP') return '🇬🇵';
  if ($code == 'GQ') return '🇬🇶';
  if ($code == 'GR') return '🇬🇷';
  if ($code == 'GS') return '🇬🇸';
  if ($code == 'GT') return '🇬🇹';
  if ($code == 'GU') return '🇬🇺';
  if ($code == 'GW') return '🇬🇼';
  if ($code == 'GY') return '🇬🇾';
  if ($code == 'HK') return '🇭🇰';
  if ($code == 'HM') return '🇭🇲';
  if ($code == 'HN') return '🇭🇳';
  if ($code == 'HR') return '🇭🇷';
  if ($code == 'HT') return '🇭🇹';
  if ($code == 'HU') return '🇭🇺';
  if ($code == 'ID') return '🇮🇩';
  if ($code == 'IE') return '🇮🇪';
  if ($code == 'IL') return '🇮🇱';
  if ($code == 'IM') return '🇮🇲';
  if ($code == 'IN') return '🇮🇳';
  if ($code == 'IO') return '🇮🇴';
  if ($code == 'IQ') return '🇮🇶';
  if ($code == 'IR') return '🇮🇷';
  if ($code == 'IS') return '🇮🇸';
  if ($code == 'IT') return '🇮🇹';
  if ($code == 'JE') return '🇯🇪';
  if ($code == 'JM') return '🇯🇲';
  if ($code == 'JO') return '🇯🇴';
  if ($code == 'JP') return '🇯🇵';
  if ($code == 'KE') return '🇰🇪';
  if ($code == 'KG') return '🇰🇬';
  if ($code == 'KH') return '🇰🇭';
  if ($code == 'KI') return '🇰🇮';
  if ($code == 'KM') return '🇰🇲';
  if ($code == 'KN') return '🇰🇳';
  if ($code == 'KP') return '🇰🇵';
  if ($code == 'KR') return '🇰🇷';
  if ($code == 'KW') return '🇰🇼';
  if ($code == 'KY') return '🇰🇾';
  if ($code == 'KZ') return '🇰🇿';
  if ($code == 'LA') return '🇱🇦';
  if ($code == 'LB') return '🇱🇧';
  if ($code == 'LC') return '🇱🇨';
  if ($code == 'LI') return '🇱🇮';
  if ($code == 'LK') return '🇱🇰';
  if ($code == 'LR') return '🇱🇷';
  if ($code == 'LS') return '🇱🇸';
  if ($code == 'LT') return '🇱🇹';
  if ($code == 'LU') return '🇱🇺';
  if ($code == 'LV') return '🇱🇻';
  if ($code == 'LY') return '🇱🇾';
  if ($code == 'MA') return '🇲🇦';
  if ($code == 'MC') return '🇲🇨';
  if ($code == 'MD') return '🇲🇩';
  if ($code == 'ME') return '🇲🇪';
  if ($code == 'MF') return '🇲🇫';
  if ($code == 'MG') return '🇲🇬';
  if ($code == 'MH') return '🇲🇭';
  if ($code == 'MK') return '🇲🇰';
  if ($code == 'ML') return '🇲🇱';
  if ($code == 'MM') return '🇲🇲';
  if ($code == 'MN') return '🇲🇳';
  if ($code == 'MO') return '🇲🇴';
  if ($code == 'MP') return '🇲🇵';
  if ($code == 'MQ') return '🇲🇶';
  if ($code == 'MR') return '🇲🇷';
  if ($code == 'MS') return '🇲🇸';
  if ($code == 'MT') return '🇲🇹';
  if ($code == 'MU') return '🇲🇺';
  if ($code == 'MV') return '🇲🇻';
  if ($code == 'MW') return '🇲🇼';
  if ($code == 'MX') return '🇲🇽';
  if ($code == 'MY') return '🇲🇾';
  if ($code == 'MZ') return '🇲🇿';
  if ($code == 'NA') return '🇳🇦';
  if ($code == 'NC') return '🇳🇨';
  if ($code == 'NE') return '🇳🇪';
  if ($code == 'NF') return '🇳🇫';
  if ($code == 'NG') return '🇳🇬';
  if ($code == 'NI') return '🇳🇮';
  if ($code == 'NL') return '🇳🇱';
  if ($code == 'NO') return '🇳🇴';
  if ($code == 'NP') return '🇳🇵';
  if ($code == 'NR') return '🇳🇷';
  if ($code == 'NU') return '🇳🇺';
  if ($code == 'NZ') return '🇳🇿';
  if ($code == 'OM') return '🇴🇲';
  if ($code == 'PA') return '🇵🇦';
  if ($code == 'PE') return '🇵🇪';
  if ($code == 'PF') return '🇵🇫';
  if ($code == 'PG') return '🇵🇬';
  if ($code == 'PH') return '🇵🇭';
  if ($code == 'PK') return '🇵🇰';
  if ($code == 'PL') return '🇵🇱';
  if ($code == 'PM') return '🇵🇲';
  if ($code == 'PN') return '🇵🇳';
  if ($code == 'PR') return '🇵🇷';
  if ($code == 'PS') return '🇵🇸';
  if ($code == 'PT') return '🇵🇹';
  if ($code == 'PW') return '🇵🇼';
  if ($code == 'PY') return '🇵🇾';
  if ($code == 'QA') return '🇶🇦';
  if ($code == 'RE') return '🇷🇪';
  if ($code == 'RO') return '🇷🇴';
  if ($code == 'RS') return '🇷🇸';
  if ($code == 'RU') return '🇷🇺';
  if ($code == 'RW') return '🇷🇼';
  if ($code == 'SA') return '🇸🇦';
  if ($code == 'SB') return '🇸🇧';
  if ($code == 'SC') return '🇸🇨';
  if ($code == 'SD') return '🇸🇩';
  if ($code == 'SE') return '🇸🇪';
  if ($code == 'SG') return '🇸🇬';
  if ($code == 'SH') return '🇸🇭';
  if ($code == 'SI') return '🇸🇮';
  if ($code == 'SJ') return '🇸🇯';
  if ($code == 'SK') return '🇸🇰';
  if ($code == 'SL') return '🇸🇱';
  if ($code == 'SM') return '🇸🇲';
  if ($code == 'SN') return '🇸🇳';
  if ($code == 'SO') return '🇸🇴';
  if ($code == 'SR') return '🇸🇷';
  if ($code == 'SS') return '🇸🇸';
  if ($code == 'ST') return '🇸🇹';
  if ($code == 'SV') return '🇸🇻';
  if ($code == 'SX') return '🇸🇽';
  if ($code == 'SY') return '🇸🇾';
  if ($code == 'SZ') return '🇸🇿';
  if ($code == 'TC') return '🇹🇨';
  if ($code == 'TD') return '🇹🇩';
  if ($code == 'TF') return '🇹🇫';
  if ($code == 'TG') return '🇹🇬';
  if ($code == 'TH') return '🇹🇭';
  if ($code == 'TJ') return '🇹🇯';
  if ($code == 'TK') return '🇹🇰';
  if ($code == 'TL') return '🇹🇱';
  if ($code == 'TM') return '🇹🇲';
  if ($code == 'TN') return '🇹🇳';
  if ($code == 'TO') return '🇹🇴';
  if ($code == 'TR') return '🇹🇷';
  if ($code == 'TT') return '🇹🇹';
  if ($code == 'TV') return '🇹🇻';
  if ($code == 'TW') return '🇹🇼';
  if ($code == 'TZ') return '🇹🇿';
  if ($code == 'UA') return '🇺🇦';
  if ($code == 'UG') return '🇺🇬';
  if ($code == 'UM') return '🇺🇲';
  if ($code == 'US') return '🇺🇸';
  if ($code == 'UY') return '🇺🇾';
  if ($code == 'UZ') return '🇺🇿';
  if ($code == 'VA') return '🇻🇦';
  if ($code == 'VC') return '🇻🇨';
  if ($code == 'VE') return '🇻🇪';
  if ($code == 'VG') return '🇻🇬';
  if ($code == 'VI') return '🇻🇮';
  if ($code == 'VN') return '🇻🇳';
  if ($code == 'VU') return '🇻🇺';
  if ($code == 'WF') return '🇼🇫';
  if ($code == 'WS') return '🇼🇸';
  if ($code == 'XK') return '🇽🇰';
  if ($code == 'YE') return '🇾🇪';
  if ($code == 'YT') return '🇾🇹';
  if ($code == 'ZA') return '🇿🇦';
  if ($code == 'ZM') return '🇿🇲';
  return '🏳';
}
export default countries;
